export default __webpack_public_path__ + "static/media/cacahuete.e04a69a0.svg";